import { memo, useMemo } from 'react';
import type { MouseEventHandler } from 'react';
import { Trans } from 'react-i18next';

import TextLink from '@/components/TextLink';

type Props = {
  readonly className: string;
  readonly onClick: MouseEventHandler<HTMLAnchorElement>;
};

const TranslationSafeResendPasscode = memo(({ className, onClick }: Props) => {
  const components = useMemo(
    () => ({ a: <TextLink className={className} onClick={onClick} /> }),
    [className, onClick]
  );

  return <Trans i18nKey="description.resend_passcode" components={components} />;
});

export default TranslationSafeResendPasscode;
